/* */
import Timer from 'helpers/setTimer';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

const { getListUsers } = actions;

const timer = new Timer();

export default (data, ...dependencies) => {
  const authReducer = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  return useEffect(() => {
    const { sessionId, isLogin } = authReducer;
    if (isLogin && sessionId) {
      // Trick to fix TA-661
      timer.debounce(() => {
        dispatch(
          getListUsers({
            ...data,
          })
        );
      }, 0);
    }
  }, [authReducer.isLogin, data, ...dependencies]);
};
